import React from "react";

const NullLeasingInfos = () => (
  <div className="page-container page-container--tight px-5 mb-1">
    <h2 className="headline--4 uppercase text-center mb-2 lg:mb-1">
      Leasing ohne Anzahlung
    </h2>
    <p className="paragraph--large text-grey-darker text-center pb-5 lg:pb-10">
      So einfach und günstig wie nie zuvor!
    </p>
    <p>
      Seit über 40 Jahren ist Auto Leasing in Deutschland bekannt und beliebt.
      Sein Erfolg zeigt sich daran, dass mittlerweile
      {" "}
      <b>jedes vierte Auto in einem Leasing-Vertrag</b>
      {" "}
      genutzt wird oder
      genutzt wurde.
    </p>
    <h3 className="headline--6 uppercase mt-8 lg:mt-10">
      Leasing für Unternehmer und Co.
    </h3>
    <p className="mt-1 mb-2">
      Vor allem für
      {" "}
      <b>Unternehmer</b>
      ,
      {" "}
      <b>Selbstständige</b>
      {" "}
      und
      {" "}
      <b>Freiberufler</b>
      {" "}
      ist Leasing eine vorteilhafte Alternative, denn jede
      {" "}
      <b>Leasingrate kann in vollem Umfang von den Steuern abgesetzt werden</b>
      .
      Darüber hinaus wird im Gegensatz zum Kauf, kein Kapital gebunden. Dies
      erlaubt eine deutlich
      {" "}
      <b>flexiblere Liquiditäts- und Finanzplanung</b>
      .
      Oft sind sogar Leasingverträge inklusive Versicherung und Servicepaket
      (z.B. Wartung / Inspektion) möglich.
    </p>

    <h3 className="headline--6 uppercase mt-8 lg:mt-10">
      Leasing für Privatpersonen
    </h3>
    <p className="mt-1 mb-2">
      Für
      {" "}
      <b>Privatleute</b>
      {" "}
      ist Leasing vor allem
      {" "}
      <b>als eine günstige Finanzierungs-Methode interessant</b>
      . Leasing ohne
      Anzahlung ist eine Option, bei der der Leasing-Vertrag sicher, günstig und
      kostentransparent abgeschlossen werden kann. Dadurch bleiben sie
      finanziell flexibel und haben
      {" "}
      <b>kein Risiko oder versteckte Kosten</b>
      .
    </p>
  </div>
);

export default NullLeasingInfos;
